import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './TableCell.css';

interface IProps {
  children?: React.ReactNode;
  header?: boolean;
}

export const TableCell = (props: IProps) => {
  const { header, children } = props;

  return <td className={clsx(styles['cell'], header && styles['cell_header'])}>{children}</td>;
};
